<template>
  <svg width="14" height="17" viewBox="0 0 14 17" xmlns="http://www.w3.org/2000/svg" :fill="fill">
    <path
      d="M4.16667 13.3333H7.5C7.73611 13.3333 7.93403 13.2535 8.09375 13.0937C8.25347 12.934 8.33333 12.7361 8.33333 12.5V11.6667L9.39583 12.2292C9.53472 12.2986 9.67014 12.2917 9.80208 12.2083C9.93403 12.125 10 12.0069 10 11.8542V9.8125C10 9.65972 9.93403 9.54167 9.80208 9.45833C9.67014 9.375 9.53472 9.36806 9.39583 9.4375L8.33333 10V9.16667C8.33333 8.93056 8.25347 8.73264 8.09375 8.57292C7.93403 8.41319 7.73611 8.33333 7.5 8.33333H4.16667C3.93056 8.33333 3.73264 8.41319 3.57292 8.57292C3.41319 8.73264 3.33333 8.93056 3.33333 9.16667V12.5C3.33333 12.7361 3.41319 12.934 3.57292 13.0937C3.73264 13.2535 3.93056 13.3333 4.16667 13.3333ZM1.66667 16.6667C1.20833 16.6667 0.815972 16.5035 0.489583 16.1771C0.163194 15.8507 0 15.4583 0 15V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H7.64583C7.86805 0 8.07986 0.0416667 8.28125 0.125C8.48264 0.208333 8.65972 0.326389 8.8125 0.479167L12.8542 4.52083C13.0069 4.67361 13.125 4.85069 13.2083 5.05208C13.2917 5.25347 13.3333 5.46528 13.3333 5.6875V15C13.3333 15.4583 13.1701 15.8507 12.8437 16.1771C12.5174 16.5035 12.125 16.6667 11.6667 16.6667H1.66667ZM7.5 5V1.66667H1.66667V15H11.6667V5.83333H8.33333C8.09722 5.83333 7.8993 5.75347 7.73958 5.59375C7.57986 5.43403 7.5 5.23611 7.5 5Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'VideoFileIcon',
  props: {
    fill: {
      type: String,
      require: true,
    },
  },
};
</script>
